import { Routes } from '@angular/router';
import { FoldersTableComponent } from '@app/admin/folders-table/folders-table.component';
import { AdminGuard } from './admin/admin.guard';
import { ContractsComponent } from './admin/contracts/contracts.component';
import { LinksTableComponent } from './admin/links-table/links-table.component';
import { NewsTableComponent } from './admin/news-table/news-table.component';
import { UsersComponent } from './admin/users/users.component';
import { ErrorComponent } from './community/error/error.component';
import { HomeComponent } from './community/home/home.component';
import { ErrorGuard } from './guards/error.guard';
import { HomeGuard } from './guards/home.guard';

export enum MENU {
  NEWS = 'NEWS',
  WIDGETS = 'WIDGETS',
  LINKS = 'LINKS',
  CONTRACTS = 'CONTRACTS',
  USERS = 'USERS',
}

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [HomeGuard],
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [ErrorGuard],
  },
  {
    path: 'admin',
    canActivate: [AdminGuard],
    children: [
      {
        path: 'widgets',
        component: FoldersTableComponent,
      },
      {
        path: 'news',
        component: NewsTableComponent,
      },
      {
        path: 'links',
        component: LinksTableComponent,
      },
      {
        path: 'contracts',
        component: ContractsComponent,
      },
      {
        path: 'users',
        component: UsersComponent,
      },
      {
        path: '',
        redirectTo: 'widgets',
        pathMatch: 'prefix',
      },
    ],
  },
  {
    path: '',
    redirectTo: '/admin/widgets',
    pathMatch: 'full',
  },
  {
    path: '**',
    component: HomeComponent,
  },
];
